export const env = {
    apiBaseUrl:
        import.meta.env.VITE_API_BASE_URL || 'http://localhost:9090/api/v1',
    appEnv: import.meta.env.VITE_APP_ENV || 'local',
    isDev: import.meta.env.DEV,
    isProd: import.meta.env.PROD,
} as const;
